if (!customElements.get('ee-press-icons')) {
  class EePressIcons extends HTMLElement {
    connectedCallback() {
      this.viewport = this.querySelector('.ee-press-icons__viewport');
      this.previousButton = this.querySelector('[data-press-previous]');
      this.nextButton = this.querySelector('[data-press-next]');

      if (!this.viewport || !this.previousButton || !this.nextButton) return;

      this.handleResize = () => this.updateButtons();
      this.previousButton.addEventListener('click', () => this.move(-1));
      this.nextButton.addEventListener('click', () => this.move(1));
      this.viewport.addEventListener('scroll', () => this.updateButtons(), { passive: true });
      window.addEventListener('resize', this.handleResize);
      this.updateButtons();
    }

    disconnectedCallback() {
      if (this.handleResize) window.removeEventListener('resize', this.handleResize);
    }

    move(direction) {
      this.viewport.scrollBy({
        left: this.viewport.clientWidth * 0.75 * direction,
        behavior: 'smooth',
      });
    }

    updateButtons() {
      const maximumScroll = this.viewport.scrollWidth - this.viewport.clientWidth;
      this.previousButton.disabled = this.viewport.scrollLeft <= 1;
      this.nextButton.disabled = this.viewport.scrollLeft >= maximumScroll - 1;
    }
  }

  customElements.define('ee-press-icons', EePressIcons);
}
